import {
  Grid,
  Header,
  StatusIndicator,
  TextContent,
} from '@amzn/awsui-components-react';
import { EuiCard } from '@elastic/eui';
import { useDomainConfigQuery } from '../../DomainConfig/hooks/useDomainConfigQuery';
import { BestPracticesPanel } from '@amzn/search-services-cluster-insights-commons-lib'
import { useToastNotifications } from '../../../hooks/useToastList';
import { get } from 'lodash';
import { AnyObject } from '../../../models/types';
import { EuiPanel } from '@elastic/eui';
import { EuiTitle } from '@elastic/eui';
import { EuiFlexItem } from '@elastic/eui';
import { EuiFlexGrid } from '@elastic/eui';

interface ClusterHealth {
  status: 'green' | 'yellow' | 'red';
  active_shards: number;
  initializing_shards: number;
  unassigned_shards: number;
}

interface ClusterStats {
  indices: {
    count: number;  
    docs: {
      count: number; 
    };
  };
}

interface ClusterHealthResponse {
  clusterHealth: ClusterHealth;
  nodes: number;
  clusterStats: ClusterStats;
}

interface ClusterHealthSummaryProps {
  getClusterHealthSummaryData?: ClusterHealthResponse;
  getClusterHealthSummaryLoading: boolean;
  domainIdent: string;
  bestPracticesPanelParameters: object;
  domainData: object;
}

const ClusterHealthSummary: React.FC<ClusterHealthSummaryProps> = ({ 
  getClusterHealthSummaryData, 
  getClusterHealthSummaryLoading,
  domainIdent,
  bestPracticesPanelParameters,
  domainData
}) => {
  const getStatusType = (status) => {
    switch (status?.toLowerCase()) {
      case 'green':
        return 'success';
      case 'yellow':
        return 'warning';
      case 'red':
        return 'error';
      default:
        return 'pending';
    }
  };

  const clusterHealth = getClusterHealthSummaryData?.clusterHealth;
  const isLoading = getClusterHealthSummaryLoading;
  const totalShards = clusterHealth?.active_shards + clusterHealth?.initializing_shards + clusterHealth?.unassigned_shards;
  const totalIndices = getClusterHealthSummaryData?.clusterStats?.indices?.count;
  const totalDocuments = getClusterHealthSummaryData?.clusterStats?.indices?.docs?.count;
  const version = domainData?.domain?.rawConfig?.elasticsearchVersion?.elasticsearchVersion;
  const renderLabelValue = (title: string, value: any) => {
    return (
      <EuiFlexItem>
        <div>
          <Header variant="h3">{title}</Header>
          <TextContent>
            {isLoading
              ? <StatusIndicator type="pending">Loading...</StatusIndicator>
              : value !== undefined
              ? value
              : 'N/A'}
          </TextContent>
        </div>
      </EuiFlexItem>
    )
  };

  return (
    <EuiFlexGrid columns={2}>
      <EuiFlexItem>
      <EuiPanel paddingSize="l" hasShadow={false}>
        <EuiTitle size="s">
          <h3 >Cluster Health Summary</h3>
        </EuiTitle>
        <EuiFlexGrid columns={3}>
          {renderLabelValue('Cluster Health', (<StatusIndicator type={getStatusType(clusterHealth?.status)}>{clusterHealth?.status || 'N/A'}</StatusIndicator>))}
          {renderLabelValue('Number of nodes', getClusterHealthSummaryData?.nodes)}
          {renderLabelValue('Number of shards', totalShards)}
          {renderLabelValue('Indices', totalIndices)}
          {renderLabelValue('Documents', totalDocuments)}
          {renderLabelValue('Version', version)}
        </EuiFlexGrid>
      </EuiPanel>
      </EuiFlexItem>
      <EuiFlexItem>
      <BestPracticesPanel http={{}} notifications={{ toasts: useToastNotifications() }} domainName={domainIdent} fetchDomainDetails={() => Promise.resolve(bestPracticesPanelParameters)} />
      </EuiFlexItem>
    </EuiFlexGrid>
  );
};

export { ClusterHealthSummary };